import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "phonx.dyslexia";
const BODY_CLASS = "dyslexia-mode";

function readInitial() {
  if (typeof window === "undefined") return false;
  try {
    return window.localStorage.getItem(STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

export function useDyslexiaMode() {
  const [enabled, setEnabled] = useState(readInitial);

  useEffect(() => {
    if (typeof document === "undefined") return;
    const root = document.documentElement;
    if (enabled) root.classList.add(BODY_CLASS);
    else root.classList.remove(BODY_CLASS);
    try {
      window.localStorage.setItem(STORAGE_KEY, enabled ? "1" : "0");
    } catch (err) {
      if (process.env.NODE_ENV !== "production") {
        console.warn("[useDyslexiaMode] localStorage write failed:", err);
      }
    }
  }, [enabled]);

  const toggle = useCallback(() => setEnabled((v) => !v), []);
  return { enabled, toggle };
}
